import { render } from "./AccountData.vue?vue&type=template&id=7701bb65"
import script from "./AccountData.vue?vue&type=script&lang=js"
export * from "./AccountData.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "7701bb65"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7701bb65', script)) {
    api.reload('7701bb65', script)
  }
  
  module.hot.accept("./AccountData.vue?vue&type=template&id=7701bb65", () => {
    api.rerender('7701bb65', render)
  })

}

script.__file = "resources/js/Pages/User/Partials/AccountData.vue"

export default script